import { toNumber } from 'lodash'
import parserUtils from '../data/utils'
import { SharedTaxonomy } from '@node/wam-audience-builder'

/**
 * Parse segments received from the api
 *
 * @param {Number|String} taxonomyId
 * @param {Object[]]} segments
 * @returns {Object[]}
 */
export const parseSegments = (taxonomyId, segments, retention) =>
    segments.map(segment => ({
        taxonomyId: toNumber(taxonomyId),
        id: toNumber(segment.id),
        category: segment.custom_category,
        label: segment.label,
        isSelectable: true,
        display_order: toNumber(segment.display_order),
        hasChild: parserUtils.findChild(segments, segment.id),
        parentJsonKeyName: parserUtils.getParentJsonKeyName(segment.parent_wam_custom_segment_id, segment),
        identifier: toNumber(segment.custom_identifier),
        smartSegments: segment.smart_segments,
        smartSegmentIds: parserUtils.getSmartSegmentIds(segment.smart_segments),
        retention: retention,
        jsonKey: {
            name: 'custom_segment_' + segment.id,
            type: 'CustomSegment',
            subType: 'data',
            ids: [toNumber(segment.id)]
        }
    }))

/**
 * Parse the taxonomies received from the api
 *
 * @param {Object[]} taxonomies
 * @param {String|Number} taxonomies[].id
 * @param {String} taxonomies[].label
 * @returns {Object[]}
 */
export const parseSharedTaxonomies = shares =>
    shares.map(sharing => ({
        id: toNumber(sharing.wam_custom_taxonomy_id),
        category: 'customTaxonomy',
        label: sharing.label,
        isSelectable: false,
        lazyLoading: true,
        parentJsonKeyName: null,
        jsonKey: {
            name: 'custom_taxonomy_' + sharing.wam_custom_taxonomy_id,
            type: 'customTaxonomy',
            subType: 'customTaxonomies',
            ids: [toNumber(sharing.wam_custom_taxonomy_id)]
        },
        ownerId: toNumber(sharing.product_account_id),
        segments: {},
        segmentsAlreadyFetched: false,
        status: sharing.status
    }))

/**
 *
 * Build parameters for the api request to get the taxonomy segments
 *
 * @param {String|Number} taxonomyId
 * @returns {Array} path in first index and params in second index
 */
export const taxonomySegmentsRequestParamsConstructor = taxonomyId => {
    return [
        '/audience_admin/wam_custom_segments/details/json',
        {
            params: {
                list_limit: 0,
                conditions: { wam_custom_taxonomy_id: taxonomyId, with_smart_segments: 1 }
            }
        }
    ]
}

export const instanciateAll = (taxonomies, segments, opts = {}, previousData = []) => {
    return SharedTaxonomy.createAll(
        [
            ...taxonomies.map(taxonomy => ({
                id: parseInt(taxonomy.wam_custom_taxonomy_id),
                label: taxonomy.label,
                path: ['Sharing', 'Taxonomies'],
                selectable: false,
                category: 'SharedTaxonomy',
                ownerId: taxonomy.product_account_id,
                retention: taxonomy.recency
            })),
            ...segments.map(segment => {
                let parentCategory = 'SharedTaxonomy'
                let parentId = parseInt(segment.wam_custom_taxonomy_id)

                if (segment.parent_wam_custom_segment_id) {
                    parentCategory = 'SharedSegment'
                    parentId = parseInt(segment.parent_wam_custom_segment_id)
                }

                return {
                    id: parseInt(segment.id),
                    label: segment.label,
                    parentId: SharedTaxonomy.generateCrossId({
                        category: parentCategory,
                        id: parentId
                    }),
                    smartSegments: (segment.smart_segments || []).map(i => ({
                        createdAt: new Date(i.created_at),
                        id: i.id,
                        periodFrom: parseInt(i.period_from),
                        periodTo: parseInt(i.period_to)
                    })),
                    path: ['Sharing', 'Taxonomies'],
                    category: 'SharedSegment',
                    retention: segment.retention,
                    displayId: true,
                    frequencyOpts: opts.frequencyOpts,
                    ownerId: segment.product_account_id
                }
            })
        ],
        previousData
    )
}

export default { parseSegments, parseSharedTaxonomies, taxonomySegmentsRequestParamsConstructor }
